import { Box, Flex, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

export const SectionCard = ({
  title,
  note,
  action,
  notice,
  children,
}: {
  title: string;
  note?: ReactNode;
  action?: ReactNode;
  notice?: ReactNode;
  children: ReactNode;
}) => (
  <Box bg="smBackground" rounded="xl" border="1px solid" borderColor="smBorder" overflow="hidden">
    <Box px={{ base: "4", md: "5" }} pt="4" pb="3">
      <Flex align="center" justify="space-between" gap="4" flexWrap="wrap">
        <Flex align="baseline" gap="3" minW="0">
          <Text fontSize="lg" fontWeight="semibold">
            {title}
          </Text>
          {note}
        </Flex>
        {action}
      </Flex>
      {notice}
    </Box>
    <Box borderTop="1px solid" borderColor="smBorderSubtle">
      {children}
    </Box>
  </Box>
);
